"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serialize = void 0;
const tslib_1 = require("tslib");
const isString_1 = tslib_1.__importDefault(require("lodash/isString"));
const lowerCase_1 = tslib_1.__importDefault(require("lodash/lowerCase"));
const replace_1 = tslib_1.__importDefault(require("lodash/replace"));
const serialize = (value) => {
    if ((0, isString_1.default)(value)) {
        return (0, replace_1.default)((0, lowerCase_1.default)(value), /\s+/g, '');
    }
    return '';
};
exports.serialize = serialize;
